<template>
    <v-autocomplete
        :disabled="backSearchableDisabled"
        label="Введите номер аптеки / адрес"
        v-model="items"
        v-model:search="search"
        :items="itemsToRenderInSelect"
        return-object
        :item-title="formatItemTitle"
        variant="outlined"
        color="primary"
        density="compact"
        clearable
        multiple>
        <template #no-data>
            <v-list-item>
                <span>Данные не найдены</span>
            </v-list-item>
        </template>
        <template #selection="{ item, index }">
            <v-chip v-if="index < 3"
                :text="`${item.raw?.location ? item.raw.location.number : item.raw.number}
                        ${item.raw?.location ? item.raw.location.street : item.raw.street}
                        ${item.raw.type.name}
                        ${item.raw.item}`">
            </v-chip>
            <span v-if="index === 3" class="text-grey text-caption align-self-center">
                + еще {{ items.length - 3 }}
            </span>
        </template>
    </v-autocomplete>
</template>

<script>

export default {
    name: 'SelectBackSearchableElement',
    props: {
        loaded_items: {
            type: Array,
            default: []
        },
        picked_items: {
            type: Array,
            default: []
        },
        pages: {
            type: Number,
            default: 1
        },
        mountedGetItems: {
            type: Boolean,
            default: true
        },
        backSearchableDisabled: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            limit: 9999,
            current_page: 1, // при инициализации в дате эквивалентно лимиту
            search: '',
            elements: [],
            observer: null,
            items: [],
            renderFrom: 0,
            renderTo: 100,
            selectRenderFrom: 0,
            selectRenderTo: 100,
            shownItems: [],
            search_timeout: false,
        }
    },
    emits: [
        'getItems',
        'syncItems'
    ],
    watch: {
        search: function () {
            this.shownItems = [];

            if(this.search_timeout !== false) {
                clearTimeout(this.search_timeout);
            }

            this.search_timeout = setTimeout(() => {
                this.elements.forEach(element => {
                    if (element.location.number.includes(this.search) || element.location.street.toLowerCase()?.includes(this.search?.toLowerCase()) && !this.filteredItems.includes(element)) {
                        this.filteredItems.push(element)
                    }
                });
                this.shownItems = this.filteredItems;
                this.search_timeout = false;
            }, 1000);
        },
        picked_items: {
            handler(newValue) {
                if (newValue) {
                    this.items = this.picked_items;
                }
            },
            deep: true,
            immediate: true
        },
        loaded_items: {
            handler: function() {
                this.updateElements();
            },
            immediate: true
        },
        items: {
            handler: function () {
                this.$emit('syncItems', this.items);
            },
            deep: true
        }
    },
    methods: {
        formatItemTitle(item) {
            return `${item.location?.number}
                    ${item.location?.street}
                    ${item.type.name}
                    ${item.item}`;
        },
        selectSearch(item, search, text) {
            const fullText = this.formatItemTitle(item).toLowerCase();
            return fullText.includes(search.toLowerCase());
        },
        removeItem(index) {
            this.items.splice(index, 1);
        },
        getItems: function() {
            this.$emit('getItems', this.search, this.limit, this.current_page);
        },
        updateElements: function() {
            this.shownItems = [];
            this.elements = this.loaded_items;
            this.shownItems = this.elements;
        },
        clearDevices() {
            this.items = [];
        },
    },
    computed: {
        filteredItems() {
            if (!this.search) return this.shownItems;
            return this.shownItems.filter(item => 
                this.formatItemTitle(item).toLowerCase().includes(this.search.toLowerCase())
            );
        },
        visibleItems() {
            return this.items.slice(this.renderFrom, this.renderTo);
        },
        itemsToRenderInSelect() {
            return this.filteredItems.slice(this.selectRenderFrom, this.selectRenderTo);
        }
    },
    mounted() {
        this.items = this.picked_items;
        if (this.mountedGetItems) {
            this.getItems();
        }
    },
}
</script>

<style scoped lang="scss">
.loader {
    text-align: center;
    color: #bbbbbb;
}
.schedule-component {
	&__select {
		max-width: 400px;
	}
    &__text-input {
        @extend.schedule-component__select;
    }
	&__btns {
		display: flex;
		gap: 16px;
		button {
			width: 214px;
		}
	}
	&__selected-items {
		display: flex;
		flex-direction: column;
		max-height: 170px;
		max-width: 710px;
		overflow-y: auto;
		gap: 10px;
		.selected-item {
			display: flex;
			align-items: center;
			justify-content: center;
			&__text {
				font-size: 16px;
				font-weight: 400;
				color: #0678F4;
			}
			&__icon {
				margin-left: auto;
				margin-right: 6px;
                min-height: 20px;
                min-width: 20px;
				cursor: pointer;
				transition: 0.2s;
				&:hover {
					color: red;
					transition: 0.2s;
				}
			}
		}
	}
}
</style>